import actionCreatorFactory from "typescript-fsa"

const actionCreator = actionCreatorFactory()
// ReduxのCompensationStartDateState更新アクション
export const compensationStartDateActions = {
  updateCompensationStartDate: actionCreator<string>("ACTIONS_UPDATE_COMPENSATION_START_DATE")
}
export default compensationStartDateActions
